import type { GetETAResponse } from '~/api/ETA';

/**
 * The ETA answered, but no warehouse serves this point.
 *
 * That is a property of the address, not of the request: a zone switched off,
 * a point outside every coverage, a fulfilment method the warehouse dropped.
 * It has to be distinguishable from a network failure, because the two need
 * opposite responses — a failed request is retried by the next poll, while an
 * address nothing can deliver to has to stop the user before the checkout,
 * which cannot calculate anything for it.
 *
 * Carries the response so reports can show what the backend actually returned.
 */
export class NoWarehouseError extends Error {
  readonly data: GetETAResponse;

  constructor(data: GetETAResponse) {
    super('No warehouse found');
    this.name = 'NoWarehouseError';
    this.data = data;
  }
}
